export default {"src":"/_next/static/media/0xbbeb516fb02a01611cbbe0453fe3c580d7281011.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};